const state = {
  auth: {
    loggedIn: false,
    token: '',
    isFetchingAuth: false,
    errorMsg: '',
    myData: {
      locale: 'it',
    },
  },
  users: {
    byId: {},
    allIds: [],
  },
  company: {
    byId: {},
    allIds: [],
  },
  activation: {
    isFetchingActivation: false,
    token: '',
    isValid: false,
    err: {},
  },
  businessInfo: {
    byId: {},
    allIds: [],
  },
  techDoc: {
    byId: {},
    allIds: [],
  },
  questionnaire: {
    byId: {},
    allIds: [],
  },
  enums: {
    errorMsg: '',
    isFetching: false,
    path: '',
  },
  orders: {
    errorMsg: '',
    isFetching: false,
    pending: {
      byId: {},
      allIds: [],
    },
    archived: {
      byId: {},
      allIds: [],
    },
  },
};

export default state;
